/* Maison Brogi — Contact form (original `Oq`) + career application form (original `Uq`). */
(function () {
  // zod's email regex (same validation as the original)
  var EMAIL_RE = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
  var MAX_CV = 4 * 1024 * 1024;

  function toast(msg, type, position) {
    if (!msg) return;
    if (window.BrogiToast) window.BrogiToast.show(msg, { type: type || 'success', position: position });
    else document.addEventListener('brogi:ready', function () { window.BrogiToast && window.BrogiToast.show(msg, { type: type || 'success', position: position }); }, { once: true });
  }
  function isUrl(v) { try { var u = new URL(v); return !!u.protocol; } catch (e) { return false; } }

  /* ------------------------------------------------------------ Contact */
  function initContact(form) {
    if (form.__brogi) return; form.__brogi = true;
    var success = form.querySelector('[data-contact-success]');
    var fields = form.querySelector('[data-contact-fields]');
    var subject = form.querySelector('[data-field="subject"]');
    var pills = Array.prototype.slice.call(form.querySelectorAll('[data-subject]'));
    var submit = form.querySelector('button[type="submit"]');

    if (success && !success.hidden && success.getAttribute('data-toast')) {
      toast(success.getAttribute('data-toast'), 'success', 'top-center');
    }

    function setError(name, msg) {
      var p = form.querySelector('[data-error-for="' + name + '"]');
      var input = form.querySelector('[data-field="' + name + '"]');
      if (p) { p.textContent = msg || ''; p.hidden = !msg; }
      if (input && input.type !== 'hidden') { if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
    }

    pills.forEach(function (btn) {
      btn.addEventListener('click', function () {
        subject.value = btn.getAttribute('data-subject');
        pills.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        setError('subject', '');
      });
    });
    Array.prototype.forEach.call(form.querySelectorAll('input[data-field], textarea[data-field]'), function (el) {
      if (el.type === 'hidden') return;
      el.addEventListener('input', function () { setError(el.getAttribute('data-field'), ''); });
    });

    var reset = form.querySelector('[data-contact-reset]');
    if (reset) reset.addEventListener('click', function () {
      form.reset();
      subject.value = '';
      pills.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      Array.prototype.forEach.call(form.querySelectorAll('input[type=text], input[type=email], textarea'), function (el) { el.value = ''; });
      success.hidden = true; fields.hidden = false;
      if (history.replaceState) history.replaceState(null, '', location.pathname);
    });

    form.addEventListener('submit', function (e) {
      var get = function (n) { var el = form.querySelector('[data-field="' + n + '"]'); return el ? el.value.trim() : ''; };
      var errs = {};
      var maxMsg = function (n) { return (form.querySelector('[data-field="name"]').getAttribute('data-max') || '').replace('[n]', n); };
      // same rules + messages as the original zod schema (first issue per field)
      if (!get('name')) errs.name = form.querySelector('[data-field="name"]').getAttribute('data-required');
      else if (get('name').length > 100) errs.name = maxMsg(100);
      if (!EMAIL_RE.test(get('email'))) errs.email = form.querySelector('[data-field="email"]').getAttribute('data-email');
      else if (get('email').length > 255) errs.email = maxMsg(255);
      if (!get('subject')) errs.subject = subject.getAttribute('data-required');
      if (!get('message')) errs.message = form.querySelector('[data-field="message"]').getAttribute('data-required');
      else if (get('message').length > 2000) errs.message = maxMsg(2000);
      ['name', 'email', 'subject', 'message'].forEach(function (n) { setError(n, errs[n] || ''); });
      if (Object.keys(errs).length) { e.preventDefault(); return; }
      // trim values like the original (zod .trim()) and submit natively to Shopify
      Array.prototype.forEach.call(form.querySelectorAll('input[type=text], input[type=email], textarea'), function (el) { el.value = el.value.trim(); });
      if (submit) {
        submit.disabled = true;
        var label = submit.querySelector('[data-label]');
        if (label) label.textContent = submit.getAttribute('data-sending-label');
      }
    });
  }

  /* ------------------------------------------------------------ Career application */
  function initCareer(root) {
    if (root.__brogi) return; root.__brogi = true;
    var form = root.querySelector('form');
    if (!form) return;
    var d = root.dataset;
    var thanksWrap = root.querySelector('[data-career-thanks-wrap]');
    var endpoint = d.endpoint;
    var file = null;
    var fileInput = form.querySelector('#applicant-cv');
    var fileName = form.querySelector('[data-cv-name]');
    var submit = form.querySelector('button[type="submit"]');

    function showThanks() {
      if (thanksWrap) { thanksWrap.hidden = false; form.hidden = true; }
    }
    var posted = form.querySelector('[data-career-posted]');
    if (posted) { showThanks(); toast(posted.getAttribute('data-success'), 'success', 'bottom-right'); }

    if (fileInput) fileInput.addEventListener('change', function () {
      file = (fileInput.files && fileInput.files[0]) || null;
      if (fileName) fileName.textContent = file ? file.name : fileName.getAttribute('data-default');
    });

    function val(id) { var el = form.querySelector('#' + id); return el ? el.value.trim() : ''; }
    function busy(on) {
      if (!submit) return;
      submit.disabled = on;
      var idle = submit.querySelector('[data-icon-idle]'), spin = submit.querySelector('[data-icon-busy]'), label = submit.querySelector('[data-label]');
      if (idle) idle.hidden = on;
      if (spin) spin.hidden = !on;
      if (label) {
        if (!label.getAttribute('data-idle')) label.setAttribute('data-idle', label.textContent);
        label.textContent = on ? label.getAttribute('data-busy') : label.getAttribute('data-idle');
      }
    }
    function readBase64(f) {
      return new Promise(function (resolve, reject) {
        var r = new FileReader();
        r.onload = function () { resolve(String(r.result).split(',')[1] || ''); };
        r.onerror = reject;
        r.readAsDataURL(f);
      });
    }

    form.addEventListener('submit', function (e) {
      var data = { name: val('applicant-name'), email: val('applicant-email'), phone: val('applicant-phone'), cvUrl: val('applicant-cvurl'), message: val('applicant-message') };
      var err = null;
      var maxMsg = function (n) { return (d.errorMax || '').replace('[n]', n); };
      // same order + messages as the original zod schema (first issue wins)
      if (data.name.length < 2) err = d.errorName;
      else if (data.name.length > 100) err = maxMsg(100);
      else if (!EMAIL_RE.test(data.email)) err = d.errorEmail;
      else if (data.email.length > 255) err = maxMsg(255);
      else if (data.phone.length > 40) err = maxMsg(40);
      else if (data.cvUrl && data.cvUrl.length > 500) err = maxMsg(500);
      else if (data.cvUrl && !isUrl(data.cvUrl)) err = d.errorUrl;
      else if (data.message.length > 3000) err = maxMsg(3000);
      else if (!file && !data.cvUrl) err = d.errorCv;
      else if (file && file.size > MAX_CV) err = d.errorSize;
      if (err) { e.preventDefault(); toast(err, 'error', 'bottom-right'); return; }

      if (!endpoint) {
        // native Shopify contact form: trim + submit normally
        ['applicant-name', 'applicant-email', 'applicant-phone', 'applicant-cvurl', 'applicant-message'].forEach(function (id) {
          var el = form.querySelector('#' + id); if (el) el.value = el.value.trim();
        });
        busy(true);
        return;
      }

      e.preventDefault();
      busy(true);
      (file ? readBase64(file) : Promise.resolve(''))
        .then(function (b64) {
          var headers = { 'Content-Type': 'application/json' };
          if (d.key) { headers.Authorization = 'Bearer ' + d.key; headers.apikey = d.key; }
          return fetch(endpoint, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
              name: data.name, email: data.email, phone: data.phone, cvUrl: data.cvUrl, message: data.message,
              roleTitle: d.roleTitle, roleSlug: d.roleSlug,
              cvFileName: file ? file.name : '', cvFileBase64: b64
            })
          });
        })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { if (!res.ok || !j || !j.success) throw new Error('send failed'); }); })
        .then(function () { showThanks(); toast(d.success, 'success', 'bottom-right'); })
        .catch(function () { toast(d.errorGeneric, 'error', 'bottom-right'); })
        .then(function () { busy(false); });
    });
  }

  function boot() {
    document.querySelectorAll('form[data-brogi-contact-form]').forEach(initContact);
    document.querySelectorAll('[data-brogi-career-form]').forEach(initCareer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
